export const hideZeros = (val) => {
    if (val == null || val === "") return null;
    // strip non-digits, parse
    const digits = val.toString().replace(/\D/g, "");
    return digits === "0" || isNaN(val) ? null : val.toString();
};